<script setup>
import YautyModal from '@/components/common/modals/YautyModal.vue';
import YBtn from "../form/YBtn/YBtn.vue";
const props = defineProps({
  show: Boolean
});

const modalWidth = '40%';
const modalHeight = '30dvh';   
const emit = defineEmits(["closeModal"]);
function closeModal() {
  emit('closeModal');
}

</script>

<template>
    <transition name="modal">
        <YautyModal v-if="props.show"
            :width="modalWidth"
            :height="modalHeight"
            :class="'session-modal'"
            :persistent="true"
            @closeModal="closeModal"
            >
            <template v-slot:header>
                <div class="d-block">
                    <div class="session-expired-modal-title">
                        <h5>{{ $t("session.session_expired") }}</h5>
                    </div>
                </div>
            </template>
            <template v-slot:body>
                <div>{{ $t("session.expiredMessage") }}</div>
            </template>
            <template v-slot:footer>
                <div class="modal-actions">
                    <YBtn secondary :label="$t('field.close')" @click="closeModal" :rounded="true" roundedSize="full"></YBtn>
                </div>
            </template>
        </YautyModal>
    </transition>
</template>

<style lang="scss">
.session-modal{
    .modal-container{
        display: flex;
        flex-direction: column;
        border-radius: 15px;
        padding: 0;
        min-height: 20rem;
        @media (max-width: 767px) {
            width: 80%;
        }
        @media (min-width: 768px) {
            width: 30rem;
        }
        
    }
    .modal-header{
        padding: 2rem;
    }
    .modal-body{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        flex-grow: 1;
    }
    .modal-footer{
        padding: 2rem;
        margin: 0 !important;
        .modal-actions{
            display: flex;
            align-items: center;
            justify-content: end;
        }
    }
}
.session-expired-modal-title{
    h5{
        margin-bottom: 0;
        font-weight: bold;
    }
}

</style>